import React from 'react'
import onClickOutside from 'react-onclickoutside'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import PrivilegedContent from '@components/PrivilegedContent/PrivilegedContent'
import settingsMenuContainer from './SettingsMenuContainer'
import './SettingsMenu.scss'

var links = [
	{
		path: '/admins',
		label: 'Consultants',
		permissions: ['readAny:admin']
	},
	{
		path: '/account', 
		label: 'Account',
	},
	{
		path: '/logout', 
		label: 'Logout'
	},
];

const PrivilegedNavLink = ({permissions, children, ...props}) => 
	<PrivilegedContent permissions={permissions}>
		<NavLink {...props}>{children}</NavLink>
	</PrivilegedContent>;

class SettingsMenu extends React.Component {
	constructor(props={}) {
		super(props)
		this.state = {
			listOpen: false,
		}
		this.toggleList = this.toggleList.bind(this);
	}

	handleClickOutside(e) {
		this.open = false;
	}

	set open(bool) {
		if(this.state.listOpen !== bool) 
			this.setState({listOpen: bool})
	}

	get open() {
		return this.state.listOpen;
	}

	toggleList() {
		this.open = !this.open;
	}

	render() {
		const { listOpen } = this.state;
		const { name } = this.props;
		return (
			<div className="SettingsMenu" data-open={listOpen}>
				<div className="SettingsMenu-header" onClick={this.toggleList}>
					<FontAwesomeIcon className="SettingsMenu-icon" icon="cog" />
					<div className="SettingsMenu-title">Settings</div>
				</div>
				<ul className="SettingsMenu-list">
					<div className="inner">
						<header onClick={this.toggleList}>
							Welcome{name && name.first ? ` ${name.first}` : ''},
						</header>

						{links.map(({path, label, permissions}) => 
							<li key={path} onClick={this.toggleList}>
								<PrivilegedNavLink permissions={permissions} key={path} className="SettingsMenu-link" to={path}>
									{label}
								</PrivilegedNavLink>
							</li>
						)}
						
					</div>
				</ul>
			</div>
		)
	}
}

export default settingsMenuContainer(onClickOutside(SettingsMenu));


// WEBPACK FOOTER //
// ./src/components/SettingsMenu/SettingsMenu.jsx